import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    Input,
    output,
    signal,
} from '@angular/core';
import {FormValue, TranslatePipe, TranslateService} from '@brunata-angular/util';
import {ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {VendorModelsFormGroup} from '../../../event-alarm.model';
import {LoadComponent} from '@brunata-angular/ui';

@Component({
    selector: 'app-vendor-model-list',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, TranslatePipe, LoadComponent],
    templateUrl: './vendor-model-list.component.html',
    styleUrl: './vendor-model-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorModelListComponent {
    @Input({required: true}) set vendorModels(newVendorModels: FormValue<VendorModelsFormGroup>[]) {
        this.vendorModelsSignal.set(newVendorModels);
    }

    readonly rowButtonClass = input<string>('btn-outline-danger');
    readonly rowButtonIconClass = input<string>('bi-arrow-left');

    private readonly translateService = inject(TranslateService);

    readonly vendorModelsSignal = signal<FormValue<VendorModelsFormGroup>[]>([]);
    readonly removedVendorModel = output<FormValue<VendorModelsFormGroup>>();

    readonly view = computed(() => {
        const currentVendorModels = this.vendorModelsSignal();
        return {
            vendorModels: currentVendorModels.map(model => ({
                ...model,
                translatedMeterType: this.translateService.translate(
                    'mappers_meterType.' + model.meterType,
                    'online',
                    'common',
                ),
            })),
            rowButtonClass: this.rowButtonClass(),
            rowButtonIconClass: this.rowButtonIconClass(),
        };
    });

    removeVendorModel(vendorModel: FormValue<VendorModelsFormGroup>): void {
        this.removedVendorModel.emit(vendorModel);
    }
}
